const TOGGLE_CHECKED_PROFILE = 'TOGLEE_CHECKED_PROFILE';

export const toggleCheckedProfile = {
    type: TOGGLE_CHECKED_PROFILE,
};
